<div class="chat-wrapper">
  <div class="chat-header">
    <div class="d-flex align-items-center gap-3">
      <img src="/assets/icones/vinho/chat-ajuda.svg" alt="icon" />
      <h5>Ajuda</h5>
    </div>
    <button class="ms-auto" mat-icon-button (click)="closeChat()">
      <mat-icon class="color-brand-principal" svgIcon="close-current"> </mat-icon>
    </button>
  </div>
  <div #chatHistory class="chat-history" (click)="handleLinkClick($event)">
    @for (message of messages(); track message.timestamp; let isFirstMessage = $first; let index = $index) {
      <div
        class="message-bubble position-relative font-size-14"
        [class.user]="message.sender === 'user'"
        [class.ai]="message.sender === 'ai'"
      >
        <p class="break-lines" [innerHTML]="message.text | markdownBold"></p>
        <!-- @if (isInitialMessage()) {
          <div class="d-flex flex-column mt-2 gap-2">
            @for (message of exampleMessages(); track message) {
              <button mat-stroked-button (click)="sendMessage(message)">{{ message }}</button>
            }
          </div>
        } -->
        <!-- @if (message.sender === 'ai' && message.isContactUs) {
          <div class="d-flex flex-column mt-2 gap-2">
            @for (message of contactUsMessages(); track message.label) {
              <button mat-stroked-button (click)="handleContactUsMessage(message)">
                <mat-icon [hidden]="message.label !== 'Whatsapp'">phone</mat-icon>
                <mat-icon [hidden]="message.label !== 'Email'">email</mat-icon>
                {{ message.label }}: {{ message.value }}
              </button>
            }
          </div>
        } -->

        @if (message.sender === 'ai' && message.idMessage) {
          <div class="feedback-actions">
            <button
              mat-icon-button
              class="feedback-button"
              [class.active]="message.feedback === 'informacaoUtil'"
              [disabled]="!!message.feedback"
              (click)="informacaoUtil(message, $event)"
              aria-label="Informação útil"
              matTooltip="Gostei"
            >
              <mat-icon>thumb_up</mat-icon>
            </button>
            <button
              mat-icon-button
              class="feedback-button"
              [class.active]="message.feedback === 'informacaoNaoUtil'"
              [disabled]="!!message.feedback"
              (click)="informacaoNaoUtil(message, $event)"
              aria-label="Informação não útil"
              matTooltip="Não gostei"
            >
              <mat-icon>thumb_down</mat-icon>
            </button>
          </div>
        }

        <span class="timestamp">{{ message.timestamp | date: 'shortTime' }}</span>
      </div>
    }
    @if (isLoading()) {
      <div class="message-bubble ai loading">
        <div class="typing-indicator"><span></span><span></span><span></span></div>
      </div>
    }
  </div>

  <div class="chat-input-area">
    <mat-form-field class="mb-0 pill-input me-3 chat-textarea-field">
      <textarea
        matInput
        #chatInput
        [(ngModel)]="userInput"
        (keyup.enter)="sendMessage()"
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="6"
        [maxlength]="maxLength"
        placeholder="Escreva sua dúvida..."
        [disabled]="isLoading()"
      ></textarea>
      <span class="char-counter">{{ userInput().length }}/{{ maxLength }}</span>
    </mat-form-field>

    <button class="pill-button" mat-flat-button (click)="sendMessage()" [disabled]="!userInput().trim() || isLoading()">
      Enviar
    </button>
  </div>
  <div class="chat-disclaimer">
    <p>O conteúdo gerado por IA pode conter erros</p>
  </div>
</div>
